import { useSearchParams } from 'react-router'
import { type MaterialTypes } from '@trinity/utils'
import { Grid, MaterialCard, Search, Stack, Typography } from '../../components'
import { useGlobalState } from '../../hooks'
import { BottomActionBar } from './helpers'

interface StyleflowVisualizeThreadsProps {
  threads: TrinityAPI.ThreadType[]
  materialList: MaterialTypes[]
}

export function StyleflowVisualizeThreads({ threads, materialList }: StyleflowVisualizeThreadsProps) {
  const { onMobile, onTablet } = useGlobalState()
  const isMobile = onMobile || onTablet
  const threadIndex = materialList.findIndex(material => material === 'thread')

  return (
    <Stack spacing={4} pb={14}>
      <Typography variant='h5' align={isMobile ? 'center' : 'left'}>
        Threads
      </Typography>
      <Stack px={1}>
        <Search name='q' method='get' />
      </Stack>
      <ThreadList threads={threads} />
      <BottomActionBar lastMaterial={materialList[threadIndex - 1]} nextMaterial={materialList[threadIndex + 1]} />
    </Stack>
  )
}

function ThreadList({ threads }: Pick<StyleflowVisualizeThreadsProps, 'threads'>) {
  const [params, setParams] = useSearchParams()

  return (
    <Grid container spacing={2} justifyContent={{ mobile: 'center', laptop: 'flex-start' }}>
      {threads.map(thread => (
        <Grid key={thread.id}>
          <MaterialCard
            onClick={() =>
              setParams(params => {
                params.set('threadId', String(thread.id))
                return params
              })
            }
            image={thread.image}
            headerText={thread.code ?? ''}
            subText={thread.description}
            selected={String(thread.id) === params.get('threadId')}
          />
        </Grid>
      ))}
    </Grid>
  )
}
